const styles = theme => ({
  responsiveDialogContent: {
    minHeight: "400px",
    minWidth: "600px",
    padding: "0",
    [theme.breakpoints.down("sm")]: {
      minWidth: "auto",
      minHeight: "auto",
    },
  },
})

export default styles
